export const GuidClaimType = 'guid_id';

export const IsInternalClientClaim = 'is_internal_client';

export const IsExternalClientClaim = 'is_external_client';

export const EmailClaimType = 'Email';

export const OrgIdentityClaimType = 'OrgIdentity';

export const EndpointClaimType = 'Endpoint';

export const SharedSecretType = 'SharedSecret';

export const DefaultAllowedScope = ['profile', 'email', 'openid', 'defaultapi'];
